<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <!-- <ion-title v-if="job.startDate">
      <template v-if="checkJobDateStart(job.startDate, job.endDate)">
        <span>{{ checkJobDateStart(job.startDate, job.endDate, true) }}</span>
      </template>
</ion-title> -->
    <ion-buttons slot="end">
      <ion-button
        class="button_more"
        @click="moreBottomDropUp = true"
        data-testid="button-more"
        v-if="userRole !== 'pharmacy'"
      >
        <ion-icon name="ellipsis-vertical-outline"></ion-icon>
      </ion-button>
      <ion-button @click="share()" v-else>
        <i class="el-icon-share"></i>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="main_wrapper ion-padding">
    <div class="container">
      <div class="job_info_wrapper">
        <div
          class="image_text_comp"
          v-if="job.pharmacy && userRole == 'locum'"
          @click="userInfoModalOpen('pharmacy')"
        >
          <div class="image_wrapper">
            <el-avatar
              :size="74"
              shape="square"
              :src="job.pharmacy.image"
              v-if="job.pharmacy.image"
            />
            <el-avatar
              :size="74"
              shape="square"
              icon="el-icon-user-solid"
              v-else
            ></el-avatar>
          </div>
          <div class="text_wrapper">
            <div class="main_text">{{ job.pharmacy.name }}</div>
            <div class="additional_text">
              <span class="distance">
                <!-- <span class="locumate_icons locumate_icon-cursor"></span> -->
                <span v-if="job.distance">{{ distanceInMiles(job.distance,'km',true) }} away</span>
                <!-- <span class="symb_infinity" v-else></span>
                <span class="symb_dot"></span> -->
              </span>
              <!-- <span>{{ $filters.addressText(job.pharmacy.address) }}</span> -->
            </div>
          </div>
        </div>

        <div class="info-separator"></div>

        <div class="rate_shifts_info">
          <div class="info_wrapper d-flex align-items-center">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.3334 10C18.3334 14.6 14.6 18.3334 10 18.3334C5.40002 18.3334 1.66669 14.6 1.66669 10C1.66669 5.40002 5.40002 1.66669 10 1.66669C14.6 1.66669 18.3334 5.40002 18.3334 10Z"
                stroke="rgb(var(--locumate-primary-color-dark))"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M13.0917 12.65L10.5083 11.1084C10.0583 10.8417 9.69165 10.2 9.69165 9.67503V6.25836"
                stroke="rgb(var(--locumate-primary-color-dark))"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <div class="info_title">
              Available Shifts
              <span>{{ checkJobDateStart(job.startDate, job.endDate) }}</span>
            </div>
            <!-- <div class="info_value">
              <span>{{ checkJobDateStart(job.startDate, job.endDate) }}</span>
            </div> -->
          </div>

          <template v-if="isAustralia">
            <div
              class="info_wrapper d-flex align-items-center"
              v-if="
                !job.isInternalStaffOfThisPharmacy &&
                job.isVisibileAsInternalLocum === false
              "
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.22656 11.9415C7.22656 13.0165 8.05156 13.8832 9.07656 13.8832H11.1682C12.0599 13.8832 12.7849 13.1248 12.7849 12.1915C12.7849 11.1748 12.3432 10.8165 11.6849 10.5832L8.32656 9.41652C7.66823 9.18318 7.22656 8.82485 7.22656 7.80818C7.22656 6.87485 7.95156 6.11652 8.84323 6.11652H10.9349C11.9599 6.11652 12.7849 6.98318 12.7849 8.05818"
                  stroke="rgb(var(--locumate-primary-color-dark))"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10 5V15"
                  stroke="rgb(var(--locumate-primary-color-dark))"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10 18.3334C14.6024 18.3334 18.3334 14.6024 18.3334 10C18.3334 5.39765 14.6024 1.66669 10 1.66669C5.39765 1.66669 1.66669 5.39765 1.66669 10C1.66669 14.6024 5.39765 18.3334 10 18.3334Z"
                  stroke="rgb(var(--locumate-primary-color-dark))"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div class="d-flex flex-wrap gap-y-2" >
                <div class="info_title">Hourly rate (excluding super)</div>
                <div class="info_value" v-if="userRole == 'pharmacy'">
                  {{ formatHourlyRatePharmacy() }}
                  <span>{{
                    formatHourlyRate(
                      job.recommendedRate,
                      job.recommendedWeekendRate
                    )
                  }}</span>
                </div>
                <div class="info_value" v-else>
                  {{
                    formatHourlyRate(
                      job.recommendedRate,
                      job.recommendedWeekendRate
                    )
                  }}
                </div>
              </div>
              <!-- <div class="info_value" v-else>
                  {{
                  formatHourlyRate(job.recommendedRate, job.recommendedWeekendRate)
                  }}
                </div> -->
            </div>
          </template>
          <template v-else>
            <div
              class="info_wrapper d-flex align-items-center"
              v-if="
                !job.isInternalStaffOfThisPharmacy &&
                job.isVisibileAsInternalLocum === false
              "
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.22656 11.9415C7.22656 13.0165 8.05156 13.8832 9.07656 13.8832H11.1682C12.0599 13.8832 12.7849 13.1248 12.7849 12.1915C12.7849 11.1748 12.3432 10.8165 11.6849 10.5832L8.32656 9.41652C7.66823 9.18318 7.22656 8.82485 7.22656 7.80818C7.22656 6.87485 7.95156 6.11652 8.84323 6.11652H10.9349C11.9599 6.11652 12.7849 6.98318 12.7849 8.05818"
                  stroke="rgb(var(--locumate-primary-color-dark))"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10 5V15"
                  stroke="rgb(var(--locumate-primary-color-dark))"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M10 18.3334C14.6024 18.3334 18.3334 14.6024 18.3334 10C18.3334 5.39765 14.6024 1.66669 10 1.66669C5.39765 1.66669 1.66669 5.39765 1.66669 10C1.66669 14.6024 5.39765 18.3334 10 18.3334Z"
                  stroke="rgb(var(--locumate-primary-color-dark))"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div class="d-flex flex-wrap gap-y-2">
                <div class="info_title">Hourly rate</div>
                <div class="info_value" v-if="userRole == 'pharmacy'">
                  {{ formatHourlyRatePharmacy() }}
                </div>
                <div class="info_value" v-else>
                  {{
                    formatHourlyRate(
                      job.recommendedRate,
                      job.recommendedWeekendRate
                    )
                  }}
                </div>
              </div>
             
            </div>
          </template>       
          
          <div class="info_wrapper d-flex align-items-center" v-if="!job.isInternalStaffOfThisPharmacy &&
                    job.isVisibileAsInternalLocum === false">
            <div
            class="d-flex flex-wrap gap-y-2"
            v-if="
              job.settings.payingForTravel == 3 &&
              job.maxTravelCompensation !== 0 && userRole == 'pharmacy'
            "
          >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.72501 3.83334C2.39167 0.950004 6.73334 0.950004 7.39167 3.83334C7.78334 5.525 6.70834 6.95834 5.77501 7.85C5.09167 8.5 4.01667 8.49167 3.33334 7.85C2.40834 6.95834 1.33334 5.525 1.72501 3.83334Z" stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"></path><path d="M12.5583 13.8333C13.225 10.95 17.5917 10.95 18.2583 13.8333C18.65 15.525 17.575 16.9583 16.6333 17.85C15.95 18.5 14.8667 18.4917 14.1833 17.85C13.2417 16.9583 12.1667 15.525 12.5583 13.8333Z" stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5"></path><path d="M9.99997 4.16699H12.2333C13.775 4.16699 14.4916 6.07533 13.3333 7.09199L6.67497 12.917C5.51664 13.9253 6.23331 15.8337 7.76664 15.8337H9.99997" stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M4.57185 4.58366H4.58148" stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path d="M15.4052 14.5837H15.4148" stroke="rgb(var(--locumate-primary-color-dark))" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            <div class="d-flex flex-wrap gap-y-2">
              <div class="info_title">Capped Travel</div>
              <div class="info_value">
                <span>{{ formatCurrency(job.maxTravelCompensation) }}</span>
              </div>
            </div>
          </div>
          </div>



        </div>

        <div class="info-separator-without-border mb-0"></div>

        <!-- @change="handleChange" -->
        <el-collapse accordion v-if="job.settings !== null" class="job-about-collapse">
          <el-collapse-item
            class="card-accordeon"
            title="More about the job"
            name="first"
          >
            <div class="collapse-list more-info">
              <div class="nested-collapse-wrapper" v-if="userRole === 'locum' && shouldDisplay">
                <el-collapse accordion="true" v-model="activeNames">
                  <el-collapse-item class="card-accordeon card-accordeon--nested" title="Script Numbers, Software and Services" name="1">
                    <div class="collapse-list more-info">
                      <div class="collapse-item" v-if="job.pharmacy.environment.scriptsPerDay">
                        <span class="collapse-title">Average scripts per day (weekdays)</span>
                        <span class="collapse-value">
                          {{ getScriptName(job.pharmacy.environment.scriptsPerDay) }}
                        </span>
                      </div>
                      <div class="collapse-item" v-if="job.pharmacy.averageScriptsSaturdayId">
                        <span class="collapse-title">Average scripts on Saturday</span>
                        <span class="collapse-value">
                          {{ getScriptName(job.pharmacy.averageScriptsSaturdayId) }}
                        </span>
                      </div>
                      <div class="collapse-item" v-if="job.pharmacy.averageScriptsSundayId">
                        <span class="collapse-title">Average scripts on Sunday</span>
                        <span class="collapse-value">
                          {{ getScriptName(job.pharmacy.averageScriptsSundayId) }}
                        </span>
                      </div>
                      <div class="collapse-item" v-if="job.pharmacy.environment.software">
                        <span class="collapse-title">Dispensing software</span>
                        <span class="collapse-value" v-if="getSoftwareName(job.pharmacy.environment.software) === 'Other'">
                          {{ getSoftwareName(job.pharmacy.environment.software) }}:
                          {{ job.pharmacy.settings.softwareOther }}
                        </span>
                        <span class="collapse-value" v-else>
                          {{ getSoftwareName(job.pharmacy.environment.software) }}
                        </span>
                      </div>
                      <div class="collapse-item collapse-item--services" v-if="job.pharmacy.environment.services">
                        <span class="collapse-title">Services</span>
                        <span class="collapse-value">
                          <el-tag class="white" v-for="service in job.pharmacy.environment.services" :key="service">
                            {{ service.name }}
                          </el-tag>
                        </span>
                      </div>
                    </div>
                  </el-collapse-item>
                </el-collapse>
              </div>
              <template v-if="isAustralia">
                <div
                  class="collapse-item"
                  v-if="
                    !job.isInternalStaffOfThisPharmacy &&
                    job.isVisibileAsInternalLocum === false
                  "
                >
                  <span class="collapse-title"
                    >Hourly Rate (excluding super)</span
                  >
                  <span class="collapse-value" v-if="userRole == 'pharmacy'">
                    {{ formatHourlyRatePharmacy() }}
                  </span>
                  <span class="collapse-value" v-else>
                    {{
                      formatHourlyRate(
                        job.recommendedRate,
                        job.recommendedWeekendRate
                      )
                    }}</span
                  >
                </div>
              </template>
              <template v-else>
                <div
                  class="collapse-item"
                  v-if="
                    !job.isInternalStaffOfThisPharmacy &&
                    job.isVisibileAsInternalLocum === false
                  "
                >
                  <span class="collapse-title"
                    >Hourly Rate</span
                  >
                  <span class="collapse-value" v-if="userRole == 'pharmacy'">
                    {{ formatHourlyRatePharmacy() }}
                  </span>
                  <span class="collapse-value" v-else>
                    {{
                      formatHourlyRate(
                        job.recommendedRate,
                        job.recommendedWeekendRate
                      )
                    }}</span
                  >
                </div>
              </template>

              <div v-if="job.settings.languages" class="collapse-item">
                <span class="collapse-title">Language</span>
                <span class="collapse-value">{{
                  job.settings.languageNames
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title"
                  >Solo {{ $filters.systemLocumName(false, true) }}</span
                >
                <span class="collapse-value">{{
                  job.settings.solo == 1 ? "Yes" : "No"
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">
                  {{ message.Immuniser }} req?</span
                >
                <span class="collapse-value">{{
                  job.covidCertRequired == 0
                    ? "Not Required"
                    : job.covidCertRequired == 1
                    ? "Mandatory"
                    : "Nice to Have"
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Number of technicians</span>
                <span class="collapse-value">{{ job.settings.numOfTech }}</span>
              </div>
              <template v-if="!job.isInternalStaffOfThisPharmacy &&
                    job.isVisibileAsInternalLocum === false">
                <div
                  class="collapse-item"
                  v-if="
                    job.settings.payingForTravel == 3 &&
                    job.maxTravelCompensation !== 0
                  "
                >
                  <span class="collapse-title">Pay for Travel</span>
                  <span class="collapse-value">{{ job.enableTravelAllowanceForFirstAndLastDay === 1 ? "Pay for first and last day of shift" : "Capped Travel" }}</span>
                </div>
                <div class="collapse-item" v-else>
                  <span class="collapse-title"
                    >Pay for Travel
                    {{
                      job.settings.payingForTravel == 1
                        ? " (>50KM roundtrip)"
                        : ""
                    }}
                  </span>
                  <span class="collapse-value">{{
                      job.enableTravelAllowanceForFirstAndLastDay === 1
                        ? "Pay for first and last day of shift"
                        : job.settings.payingForTravel === 0
                          ? "No travel"
                          : job.settings.payingForTravel === 1
                            ? "Partial travel"
                            : "Full travel"
                    }}</span>
                </div>
              </template>
              <div class="collapse-item">
                <span class="collapse-title">Pay for Flights</span>
                <span class="collapse-value">{{
                  job.settings.payForFlights == 0 ? "No" : "Yes"
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Pay for Accommodation</span>
                <span class="collapse-value">{{
                  job.settings.payForAccommodation == 0 ? "No" : "Yes"
                }}</span>
              </div>
              <div class="collapse-item" v-if="isAustralia">
                <span class="collapse-title">Dosage Administration Aids</span>
                <span class="collapse-value">{{
                  job.settings.adminAids == 1 ? "Yes" : "No"
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Open Pharmacy</span>
                <span class="collapse-value">{{
                  job.settings.openUp == 1 ? "Yes" : "No"
                }}</span>
              </div>
              <div class="collapse-item">
                <span class="collapse-title">Close Pharmacy</span>
                <span class="collapse-value">{{
                  job.settings.close == 1 ? "Yes" : "No"
                }}</span>
              </div>
              <div v-if="job.settings.notes" class="collapse-item collapse-item--notes">
                <span class="collapse-title">Notes</span>
                <p class="job-notes__content">{{ job.settings.notes }}</p>
              </div>
              <div v-if="job.settings.parking" class="collapse-item collapse-item--notes">
                <span class="collapse-title">Parking</span>
                <p class="job-notes__content">{{ job.settings.parking }}</p>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>

      <div class="info-separator-without-border mt-0"></div>

      <el-form
        class="job_shifts_wrapper"
        :model="formsData.dayForm"
        :rules="formsData.dayForm.rules"
        :ref="(el) => (formsData.dayForm.ref = el)"
        :label-position="'top'"
        @submit.prevent="submit('dayForm')"
      >
        <el-form-item prop="jobShifts" class="job_shifts_form_checkbox">
          <div
            class="job_shifts_title info-section-title d-flex align-items-center justify-content-between mb-20"
            v-if="pastShiftsMark"
          >
            Past shifts
          </div>

          <template
            v-for="(shift, i) in formsData.dayForm.jobShifts.value"
            :key="shift.date"
          >
            <div
              class="job_shifts_title info-section-title d-flex align-items-center justify-content-between mb-20"
              v-if="featureShiftsMarkArray[i]"
            >
              Future shifts

              <el-button
                class="icon-button text-only"
                @click="goNext('dayForm')"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.75 3.56V2C16.75 1.59 16.41 1.25 16 1.25C15.59 1.25 15.25 1.59 15.25 2V3.5H8.74999V2C8.74999 1.59 8.40999 1.25 7.99999 1.25C7.58999 1.25 7.24999 1.59 7.24999 2V3.56C4.54999 3.81 3.23999 5.42 3.03999 7.81C3.01999 8.1 3.25999 8.34 3.53999 8.34H20.46C20.75 8.34 20.99 8.09 20.96 7.81C20.76 5.42 19.45 3.81 16.75 3.56Z"
                    fill="rgb(var(--locumate-primary-color-dark))"
                  />
                  <path
                    d="M20 9.84H4C3.45 9.84 3 10.29 3 10.84V17C3 20 4.5 22 8 22H16C19.5 22 21 20 21 17V10.84C21 10.29 20.55 9.84 20 9.84ZM9.21 18.21C9.16 18.25 9.11 18.3 9.06 18.33C9 18.37 8.94 18.4 8.88 18.42C8.82 18.45 8.76 18.47 8.7 18.48C8.63 18.49 8.57 18.5 8.5 18.5C8.37 18.5 8.24 18.47 8.12 18.42C7.99 18.37 7.89 18.3 7.79 18.21C7.61 18.02 7.5 17.76 7.5 17.5C7.5 17.24 7.61 16.98 7.79 16.79C7.89 16.7 7.99 16.63 8.12 16.58C8.3 16.5 8.5 16.48 8.7 16.52C8.76 16.53 8.82 16.55 8.88 16.58C8.94 16.6 9 16.63 9.06 16.67C9.11 16.71 9.16 16.75 9.21 16.79C9.39 16.98 9.5 17.24 9.5 17.5C9.5 17.76 9.39 18.02 9.21 18.21ZM9.21 14.71C9.02 14.89 8.76 15 8.5 15C8.24 15 7.98 14.89 7.79 14.71C7.61 14.52 7.5 14.26 7.5 14C7.5 13.74 7.61 13.48 7.79 13.29C8.07 13.01 8.51 12.92 8.88 13.08C9.01 13.13 9.12 13.2 9.21 13.29C9.39 13.48 9.5 13.74 9.5 14C9.5 14.26 9.39 14.52 9.21 14.71ZM12.71 18.21C12.52 18.39 12.26 18.5 12 18.5C11.74 18.5 11.48 18.39 11.29 18.21C11.11 18.02 11 17.76 11 17.5C11 17.24 11.11 16.98 11.29 16.79C11.66 16.42 12.34 16.42 12.71 16.79C12.89 16.98 13 17.24 13 17.5C13 17.76 12.89 18.02 12.71 18.21ZM12.71 14.71C12.66 14.75 12.61 14.79 12.56 14.83C12.5 14.87 12.44 14.9 12.38 14.92C12.32 14.95 12.26 14.97 12.2 14.98C12.13 14.99 12.07 15 12 15C11.74 15 11.48 14.89 11.29 14.71C11.11 14.52 11 14.26 11 14C11 13.74 11.11 13.48 11.29 13.29C11.38 13.2 11.49 13.13 11.62 13.08C11.99 12.92 12.43 13.01 12.71 13.29C12.89 13.48 13 13.74 13 14C13 14.26 12.89 14.52 12.71 14.71ZM16.21 18.21C16.02 18.39 15.76 18.5 15.5 18.5C15.24 18.5 14.98 18.39 14.79 18.21C14.61 18.02 14.5 17.76 14.5 17.5C14.5 17.24 14.61 16.98 14.79 16.79C15.16 16.42 15.84 16.42 16.21 16.79C16.39 16.98 16.5 17.24 16.5 17.5C16.5 17.76 16.39 18.02 16.21 18.21ZM16.21 14.71C16.16 14.75 16.11 14.79 16.06 14.83C16 14.87 15.94 14.9 15.88 14.92C15.82 14.95 15.76 14.97 15.7 14.98C15.63 14.99 15.56 15 15.5 15C15.24 15 14.98 14.89 14.79 14.71C14.61 14.52 14.5 14.26 14.5 14C14.5 13.74 14.61 13.48 14.79 13.29C14.89 13.2 14.99 13.13 15.12 13.08C15.3 13 15.5 12.98 15.7 13.02C15.76 13.03 15.82 13.05 15.88 13.08C15.94 13.1 16 13.13 16.06 13.17C16.11 13.21 16.16 13.25 16.21 13.29C16.39 13.48 16.5 13.74 16.5 14C16.5 14.26 16.39 14.52 16.21 14.71Z"
                    fill="rgb(var(--locumate-primary-color-dark))"
                  />
                </svg>
              </el-button>
            </div>
            <div
              class="card-wrapper"
              v-touch:swipe.left="() => onSwipeLeft(shift, i)"
              v-touch:swipe.right="() => onSwipeRight(shift, i)"
              :class="{
                swipedLeft:
                  showActions[i] &&
                  (shift.abilities.delete || shift.abilities.exit) &&
                  shift.status != 13,
              }"
            >
              <div class="job_shift_item1">
                <div class="job_shift_info1">
                  <div class="job_shift_text">
                    <div @click="handleClick(shift)" class="job_shift_user1">
                      <template v-if="shift.locum">
                        <el-avatar
                          :size="30"
                          shape="square"
                          :src="shift.locum.image"
                          v-if="shift.locum.image"
                        />
                        <el-avatar
                          :size="30"
                          class=""
                          shape="square"
                          icon="locumate_icons locumate_icon-user1 locumate_icons-avatar"
                          v-else
                        ></el-avatar>
                          <div v-if="userRole == 'agency'">
                            <strong>
                              Locum: {{ shift.shiftAgencyLocum.firstName }}
                              {{ shift.shiftAgencyLocum.lastName }}
                            </strong>
                          </div>
                      </template>
                      <template v-else-if="shift.status === 14">
                        <el-avatar
                          :size="30"
                          class=""
                          shape="square"
                          icon="locumate_icons locumate_icon-user1 locumate_icons-avatar"
                        ></el-avatar>
                      </template>
                      <template v-else>
                        <template
                          v-if="
                            shift.applicationSelected == true &&
                            shift.applicationSelectedBy?.status == 2
                          "
                        >
                          <el-avatar
                            :size="30"
                            class="yellow"
                            shape="square"
                            icon="locumate_icons locumate_icon-user1 locumate_icons-avatar"
                          ></el-avatar>
                        </template>
                        <template v-else>
                          <el-avatar
                            :size="30"
                            class="grid-center gray"
                            shape="square"
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.99999 11C10.1974 11 12.119 11.9451 13.1643 13.3548L12.0591 13.8776C11.2084 12.8694 9.70843 12.2 7.99999 12.2C6.29154 12.2 4.79156 12.8694 3.94093 13.8776L2.83618 13.3543C3.88151 11.9448 5.80283 11 7.99999 11ZM7.99999 2C9.65683 2 11 3.34315 11 5V6.8C11 8.45684 9.65683 9.8 7.99999 9.8C6.34313 9.8 4.99999 8.45684 4.99999 6.8V5C4.99999 3.34315 6.34313 2 7.99999 2Z"
                                fill="rgb(var(--locumate-primary-color))"
                              />
                            </svg>
                          </el-avatar>
                        </template>
                        <div
                          class="locumate-progress"
                          v-if="shift.applicationSelected == false"
                        >
                          <div
                            v-if="
                              userRole == 'pharmacy' &&
                              shift.shiftApplicationType != 0
                            "
                          >
                            <ProgressBar
                              :totalSlots="job.maximumApplicationLimit"
                              :filledSlots="shift.totalShiftApplications"
                            />
                          </div>
                        </div>
                      </template>
                    </div>
                    <div class="day_info">
                      <div class="day_name header">
                        <div class="day" v-if="isAustralia">
                        
                          {{
                            $moment(shift.date, ["YYYY/MM/DD", "YYYY-MM-DD", "DD MMM YYYY", "D MMM YYYY", "d M Y"]).format("dddd,")
                          }}
                          {{
                            $moment(shift.date, ["YYYY/MM/DD", "YYYY-MM-DD", "DD MMM YYYY", "D MMM YYYY", "d M Y"]).format(
                              "DD MMM YYYY"
                            )
                          }}
                        </div>
                        <div class="day" v-else>
                           
                          {{
                            $moment(shift.date, ["YYYY/MM/DD", "YYYY-MM-DD", "DD MMM YYYY", "D MMM YYYY", "d M Y"]).format("dddd,")
                          }}
                          {{
                            $moment(shift.date, ["YYYY/MM/DD", "YYYY-MM-DD", "DD MMM YYYY", "D MMM YYYY", "d M Y"]).format(
                              "MMM DD YYYY"
                            )
                          }}
                        </div>
                        <div class="d-flex more-button" v-if="userRole != 'agency'">
                          <el-button
                            class="text-only icon-button"
                            v-if="shift.locum"
                            @click="goToJobCalendar(shift)"
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M6.66663 1.66663V4.16663"
                                stroke="rgb(var(--locumate-clr-text)"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M13.3334 1.66663V4.16663"
                                stroke="rgb(var(--locumate-clr-text)"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M2.91663 7.57495H17.0833"
                                stroke="rgb(var(--locumate-clr-text)"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M17.5 7.08329V14.1666C17.5 16.6666 16.25 18.3333 13.3333 18.3333H6.66667C3.75 18.3333 2.5 16.6666 2.5 14.1666V7.08329C2.5 4.58329 3.75 2.91663 6.66667 2.91663H13.3333C16.25 2.91663 17.5 4.58329 17.5 7.08329Z"
                                stroke="rgb(var(--locumate-clr-text)"
                                stroke-width="1.5"
                                stroke-miterlimit="10"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M9.9962 11.4167H10.0037"
                                stroke="rgb(var(--locumate-clr-text)"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M6.91197 11.4167H6.91945"
                                stroke="rgb(var(--locumate-clr-text)"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M6.91197 13.9167H6.91945"
                                stroke="rgb(var(--locumate-clr-text)"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </el-button>
                          <el-button
                            class="button_more icon-button text-only-black"
                            icon="el-icon-more"
                            v-if="bottomDropUpExist(shift)"
                            @click="bottomDropUp[i] = true"
                          ></el-button>
                          <i
                            class="el-icon-arrow-right"
                            @click="goToJobCalendar(shift)"
                            v-else-if="shift.locum"
                          ></i>
                        </div>
                      </div>
                    </div>
                    <div class="info-wrapper">
                      <div class="day_info_block">
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.3333 10C18.3333 14.6 14.6 18.3333 10 18.3333C5.4 18.3333 1.66667 14.6 1.66667 10C1.66667 5.40001 5.4 1.66667 10 1.66667C14.6 1.66667 18.3333 5.40001 18.3333 10Z"
                            stroke="rgb(var(--locumate-primary-color-dark))"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M13.0917 12.65L10.5083 11.1083C10.0583 10.8417 9.69167 10.2 9.69167 9.675V6.25833"
                            stroke="rgb(var(--locumate-primary-color-dark))"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                        <div class="day_time data">
                          <span>{{
                            $moment(
                              shift.userStartTime || shift.startTime,
                              "HH:mm"
                            ).format("h:mm A")
                          }}</span>
                          -
                          <span>{{
                            $moment(
                              shift.userEndTime || shift.endTime,
                              "HH:mm"
                            ).format("h:mm A")
                          }}</span
                          >&nbsp;
                          <span v-if="showShiftInformation(shift)">
                            ({{
                              confirmedHours(
                                shift.confirmedHours,
                                shift.startTime,
                                shift.endTime
                              )
                            }}
                            Hours)</span
                          >
                          <span v-else>-</span>
                        </div>
                      </div>
                      <div class="day_info_block" v-if="(!shift.shiftBookedAsInternalStaff &&
                          shift.isVisibileAsInternalLocum === false ) && userRole != 'agency'">
                        <div class="title">
                          <!-- <span>Break </span> -->
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10 18.3333C5.975 18.3333 2.70833 15.0667 2.70833 11.0417C2.70833 7.01667 5.975 3.75 10 3.75C14.025 3.75 17.2917 7.01667 17.2917 11.0417"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10 6.66699V10.8337"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M7.5 1.66699H12.5"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M15.8334 14.167V17.5003"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M13.3334 14.167V17.5003"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div class="info">
                          <span v-if="showShiftInformation(shift)">
                            {{
                              shift.userBreakMinutes
                                ? getTimeFromMinutes(shift.userBreakMinutes)
                                : "-"
                            }}</span
                          >
                          <span v-else>-</span>
                        </div>
                      </div>
                      <div
                        class="day_info_block"
                        v-if="
                          (!shift.shiftBookedAsInternalStaff &&
                          shift.isVisibileAsInternalLocum === false ) && userRole != 'agency'
                        "
                      >
                        <div class="title">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.72501 3.83334C2.39167 0.950004 6.73334 0.950004 7.39167 3.83334C7.78334 5.525 6.70834 6.95834 5.77501 7.85C5.09167 8.5 4.01667 8.49167 3.33334 7.85C2.40834 6.95834 1.33334 5.525 1.72501 3.83334Z"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                            />
                            <path
                              d="M12.5583 13.8333C13.225 10.95 17.5917 10.95 18.2583 13.8333C18.65 15.525 17.575 16.9583 16.6333 17.85C15.95 18.5 14.8667 18.4917 14.1833 17.85C13.2417 16.9583 12.1667 15.525 12.5583 13.8333Z"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                            />
                            <path
                              d="M9.99997 4.16699H12.2333C13.775 4.16699 14.4916 6.07533 13.3333 7.09199L6.67497 12.917C5.51664 13.9253 6.23331 15.8337 7.76664 15.8337H9.99997"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M4.57185 4.58366H4.58148"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M15.4052 14.5837H15.4148"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        </div>
                        <div
                          class="info"
                          v-if="job.settings.payingForTravel == 3 &&
                            job.maxTravelCompensation !== 0
                          "
                        >
                          <span>{{ job.enableTravelAllowanceForFirstAndLastDay === 1 ? "Travel" : "Capped Travel" }}</span>
                        </div>
                        <div class="info" v-else>
                          <span>Travel</span>
                        </div>
                        <div class="info">
                          <span v-if="showShiftInformation(shift)">
                            {{ travelCompensationCount(job, shift) }}
                          </span>
                          <span v-else>-</span>
                        </div>
                      </div>
                      <div
                        class="day_info_block"
                        v-if="
                          !shift.shiftBookedAsInternalStaff &&
                          shift.isVisibileAsInternalLocum === false
                        "
                      >
                        <div class="title">
                          <!-- <span>Rate</span> -->
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.22656 11.9415C7.22656 13.0165 8.05156 13.8832 9.07656 13.8832H11.1682C12.0599 13.8832 12.7849 13.1249 12.7849 12.1915C12.7849 11.1749 12.3432 10.8165 11.6849 10.5832L8.32656 9.41654C7.66823 9.18321 7.22656 8.82487 7.22656 7.80821C7.22656 6.87487 7.95156 6.11654 8.84323 6.11654H10.9349C11.9599 6.11654 12.7849 6.98321 12.7849 8.05821"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10 5V15"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39762 14.6024 1.66666 10 1.66666C5.39763 1.66666 1.66667 5.39762 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span
                            class="locumate_icons locumate_icon-check shift_confirm"
                            v-if="shift.confirmationDate"
                          ></span>
                        </div>
                        <div class="info rate" v-if="userRole != 'agency'">
                          <span
                            v-if="
                              (showShiftInformation(shift) &&
                                !shift.shiftBookedAsInternalStaff && shift.isVisibileAsInternalLocum === false) ||
                              (showShiftInformation(shift) &&
                                job.openMarketplaceShiftForInternalLocum)
                            "
                            >{{ Rate(shift) }}</span
                          >
                          <span v-else>-</span>
                        </div>
                        <div class="info rate" v-if="userRole == 'agency'">
                          <span>{{ Rate(shift) }}</span>
                        </div>
                      </div>
                      <template v-if="isAustralia && userRole != 'agency'">
                        <div
                          class="day_info_block"
                          v-if="
                            !shift.shiftBookedAsInternalStaff &&
                            shift.isVisibileAsInternalLocum === false
                          "
                        >
                          <div class="title">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.22656 11.9415C7.22656 13.0165 8.05156 13.8832 9.07656 13.8832H11.1682C12.0599 13.8832 12.7849 13.1249 12.7849 12.1915C12.7849 11.1749 12.3432 10.8165 11.6849 10.5832L8.32656 9.41654C7.66823 9.18321 7.22656 8.82487 7.22656 7.80821C7.22656 6.87487 7.95156 6.11654 8.84323 6.11654H10.9349C11.9599 6.11654 12.7849 6.98321 12.7849 8.05821"
                                stroke="rgb(var(--locumate-primary-color-dark))"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M10 5V15"
                                stroke="rgb(var(--locumate-primary-color-dark))"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39762 14.6024 1.66666 10 1.66666C5.39763 1.66666 1.66667 5.39762 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z"
                                stroke="rgb(var(--locumate-primary-color-dark))"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            <!-- <span>Total Super</span> -->
                          </div>
                          <div class="info amount">
                            <span>Total Super</span>
                            <span
                              v-if="
                                (showShiftInformation(shift) &&
                                  !shift.shiftBookedAsInternalStaff && shift.isVisibileAsInternalLocum === false) ||
                                (showShiftInformation(shift) &&
                                  job.openMarketplaceShiftForInternalLocum)
                              "
                            >
                              {{ totalSuperRate(shift) }}</span
                            >
                            <span v-else>-</span>
                          </div>
                        </div>
                      </template>
                      <div
                        class="day_info_block"
                        v-if="
                          (!shift.shiftBookedAsInternalStaff &&
                          shift.isVisibileAsInternalLocum === false) && userRole != 'agency'
                        "
                      >
                        <div class="title">
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.22656 11.9415C7.22656 13.0165 8.05156 13.8832 9.07656 13.8832H11.1682C12.0599 13.8832 12.7849 13.1249 12.7849 12.1915C12.7849 11.1749 12.3432 10.8165 11.6849 10.5832L8.32656 9.41654C7.66823 9.18321 7.22656 8.82487 7.22656 7.80821C7.22656 6.87487 7.95156 6.11654 8.84323 6.11654H10.9349C11.9599 6.11654 12.7849 6.98321 12.7849 8.05821"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10 5V15"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39762 14.6024 1.66666 10 1.66666C5.39763 1.66666 1.66667 5.39762 1.66667 10C1.66667 14.6024 5.39763 18.3333 10 18.3333Z"
                              stroke="rgb(var(--locumate-primary-color-dark))"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <!-- <span>Sum</span> -->
                        </div>
                        <div class="info amount">
                          <span>Sum </span>
                          <span
                            v-if="
                              (showShiftInformation(shift) &&
                                !shift.shiftBookedAsInternalStaff && shift.isVisibileAsInternalLocum === false) ||
                              (showShiftInformation(shift) &&
                                job.openMarketplaceShiftForInternalLocum)
                            "
                          >
                            {{ Sum(shift) }}</span
                          >
                          <span v-else>-</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="job_shift_text" v-if="isBlockShift === 0">
                    <div
                      class="job_application_wrapper"
                      v-if="
                        userRole == 'pharmacy' &&
                        shift.shiftApplicationType !== 0 &&
                        shift.locum == null
                      "
                    >
                      <el-collapse
                        accordion
                        v-model="activeCollapse"
                        v-if="shift.shiftApplications.length > 0"
                      >
                        <el-collapse-item
                          class="card-accordeon"
                          :title="`${shift.shiftApplications.length} Shift applicant${shift.shiftApplications.length > 1 ? 's' : ''}`"
                          :name="shift.id"
                        >
                          <div
                            v-for="applicant in shift.shiftApplications"
                            :key="applicant.id"
                          >
                            <div class="collapse-list applicant-list">
                              <div class="collapse-item">
                                <div class="avatar-row avatar-row--col">
                                  <div class="avatar-row-left">
                                    <template v-if="applicant.locum">
                                      <el-avatar
                                        :size="'small'"
                                        shape="square"
                                        :src="applicant.locum.image"
                                        v-if="applicant.locum.image"
                                      />
                                      <el-avatar
                                        :size="'small'"
                                        class="avatar-d"
                                        shape="square"
                                        icon="locumate_icons locumate_icon-user1 locumate_icons-avatar"
                                        v-else
                                      ></el-avatar>
                                    </template>
                                    <p>
                                      <span v-if="applicant.status === 9">{{ applicant.locum.name }} ({{ applicant.statusLabel }})</span>
                                      <span v-else>{{ applicant.locum.name }}</span>
                                      <span
                                        class="text-secondary"
                                        style="font-size: 12px"
                                      >
                                        Locum rate:
                                        <span class="rate">{{
                                          formatCurrency(applicant.locumRate)
                                        }}</span>
                                      </span>
                                    </p>
                                    <div
                                      v-if="
                                        shift.applicationSelectedBy?.status == 2
                                      "
                                      class="ml-auto"
                                    >
                                      <el-tag
                                        class="confirmation-status"
                                        v-if="
                                          shift.applicationSelectedBy?.id ==
                                          applicant.id
                                        "
                                      >
                                        Pending Confirmation
                                      </el-tag>
                                    </div>
                                    <div
                                      v-else
                                      class="day_info_block_btn ml-auto"
                                    >
                                      <el-checkbox
                                        class="c-label"
                                        :checked="isSelected(applicant.id)"
                                        @change="
                                          handleCheckboxChange(applicant.id)
                                        "
                                      ></el-checkbox>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </el-collapse-item>
                      </el-collapse>
                    </div>
                  </div>
                </div>
                <el-drawer
                  custom-class="bottom_drop_up"
                  v-model="bottomDropUp[i]"
                  :append-to-body="true"
                  :with-header="false"
                  :direction="'btt'"
                  :destroy-on-close="true"
                >
                  <el-button
                    type="transparent"
                    class="menu_item"
                    v-if="userRole == 'pharmacy' && shift.abilities.update"
                    @click="actions.editShift(job, shift, i)"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11.05 3.00002L4.20829 10.2417C3.94996 10.5167 3.69996 11.0584 3.64996 11.4334L3.34162 14.1334C3.23329 15.1084 3.93329 15.775 4.89996 15.6084L7.58329 15.15C7.95829 15.0834 8.48329 14.8084 8.74162 14.525L15.5833 7.28335C16.7666 6.03335 17.3 4.60835 15.4583 2.86668C13.625 1.14168 12.2333 1.75002 11.05 3.00002Z"
                        stroke="rgb(var(--locumate-clr-text)"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M9.90833 4.20825C10.2667 6.50825 12.1333 8.26659 14.45 8.49992"
                        stroke="rgb(var(--locumate-clr-text)"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2.5 18.3333H17.5"
                        stroke="rgb(var(--locumate-clr-text)"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span>Edit shift</span>
                  </el-button>
                  <el-button
                    type="transparent"
                    class="menu_item"
                    v-if="
                      userRole == 'pharmacy' &&
                      shift.applicationSelected == false &&
                      shift.shiftApplicationType !== 0 &&
                      shift.locum == null
                    "
                    @click="actions.viewApplicants(job, shift, i)"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.9834 10.0001C12.9834 11.6501 11.6501 12.9834 10.0001 12.9834C8.35006 12.9834 7.01672 11.6501 7.01672 10.0001C7.01672 8.35006 8.35006 7.01672 10.0001 7.01672C11.6501 7.01672 12.9834 8.35006 12.9834 10.0001Z"
                        stroke="rgb(var(--locumate-clr-text)"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M9.99999 16.8916C12.9417 16.8916 15.6833 15.1583 17.5917 12.1583C18.3417 10.9833 18.3417 9.00831 17.5917 7.83331C15.6833 4.83331 12.9417 3.09998 9.99999 3.09998C7.05833 3.09998 4.31666 4.83331 2.40833 7.83331C1.65833 9.00831 1.65833 10.9833 2.40833 12.1583C4.31666 15.1583 7.05833 16.8916 9.99999 16.8916Z"
                        stroke="rgb(var(--locumate-clr-text)"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span>View Applicants</span>
                  </el-button>
                  <el-button
                    type="transparent"
                    class="menu_item"
                    v-if="
                      userRole == 'pharmacy' &&
                      shift.applicationSelected == true &&
                      !shift.userId
                    "
                    @click="actions.removeApplicants(job, shift, i)"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 9.99996C12.3012 9.99996 14.1667 8.13448 14.1667 5.83329C14.1667 3.53211 12.3012 1.66663 10 1.66663C7.69885 1.66663 5.83337 3.53211 5.83337 5.83329C5.83337 8.13448 7.69885 9.99996 10 9.99996Z"
                        stroke="rgb(var(--locumate-clr-text))"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M2.84167 18.3333C2.84167 15.1083 6.05003 12.5 10 12.5C10.8 12.5 11.575 12.6083 12.3 12.8083"
                        stroke="rgb(var(--locumate-clr-text))"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M18.3333 15C18.3333 15.2666 18.3 15.525 18.2333 15.775C18.1583 16.1083 18.0249 16.4333 17.8499 16.7166C17.2749 17.6833 16.2166 18.3333 15 18.3333C14.1416 18.3333 13.3666 18.0083 12.7833 17.4749C12.5333 17.2583 12.3166 17 12.15 16.7166C11.8416 16.2166 11.6666 15.625 11.6666 15C11.6666 14.1 12.025 13.275 12.6083 12.675C13.2166 12.05 14.0666 11.6666 15 11.6666C15.9833 11.6666 16.8749 12.0916 17.4749 12.775C18.0083 13.3666 18.3333 14.15 18.3333 15Z"
                        stroke="rgb(var(--locumate-clr-text))"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M16.2416 14.9833H13.7583"
                        stroke="rgb(var(--locumate-clr-text))"
                        stroke-width="1.5"
                        stroke-miterlimit="10"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <span>Withdraw Applicant</span>
                  </el-button>
                  <el-button
                    type="transparent"
                    class="menu_item"
                    @click="goToJobApplicants(shift.id)"
                    v-if="
                      !shift.userId &&
                      shift.shiftApplicationType !== 0 &&
                      userRole === 'pharmacy'
                    "
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M15 5.96663C14.95 5.9583 14.8917 5.9583 14.8417 5.96663C13.6917 5.92496 12.775 4.98329 12.775 3.81663C12.775 2.62496 13.7334 1.66663 14.925 1.66663C16.1167 1.66663 17.075 2.63329 17.075 3.81663C17.0667 4.98329 16.15 5.92496 15 5.96663Z"
                        stroke="rgb(var(--locumate-clr-text)"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M14.1417 12.0333C15.2834 12.225 16.5417 12.025 17.425 11.4333C18.6 10.65 18.6 9.36664 17.425 8.58331C16.5334 7.99164 15.2584 7.79163 14.1167 7.99163"
                        stroke="rgb(var(--locumate-clr-text)"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M4.9749 5.96663C5.0249 5.9583 5.08324 5.9583 5.13324 5.96663C6.28324 5.92496 7.1999 4.98329 7.1999 3.81663C7.1999 2.62496 6.24157 1.66663 5.0499 1.66663C3.85824 1.66663 2.8999 2.63329 2.8999 3.81663C2.90824 4.98329 3.8249 5.92496 4.9749 5.96663Z"
                        stroke="rgb(var(--locumate-clr-text)"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M5.83328 12.0333C4.69162 12.225 3.43328 12.025 2.54995 11.4333C1.37495 10.65 1.37495 9.36664 2.54995 8.58331C3.44162 7.99164 4.71662 7.79163 5.85828 7.99163"
                        stroke="rgb(var(--locumate-clr-text)"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M10 12.1917C9.95002 12.1834 9.89169 12.1834 9.84169 12.1917C8.69169 12.1501 7.77502 11.2084 7.77502 10.0417C7.77502 8.85006 8.73336 7.89172 9.92502 7.89172C11.1167 7.89172 12.075 8.85839 12.075 10.0417C12.0667 11.2084 11.15 12.1584 10 12.1917Z"
                        stroke="rgb(var(--locumate-clr-text)"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.57498 14.8167C6.39998 15.6 6.39998 16.8833 7.57498 17.6667C8.90831 18.5583 11.0916 18.5583 12.425 17.6667C13.6 16.8833 13.6 15.6 12.425 14.8167C11.1 13.9333 8.90831 13.9333 7.57498 14.8167Z"
                        stroke="rgb(var(--locumate-clr-text)"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span>All Applicants</span>
                  </el-button>
                  <el-button
                    type="transparent"
                    class="menu_item red"
                    v-if="
                      userRole === 'pharmacy' &&
                      (shift.abilities.delete || shift.abilities.exit) &&
                      shift.status != 13
                    "
                     @click="isBlockShift=== 1 ? actions.bulkViewShifts(job,shift,i) : actions.openDialog(job, shift, i)"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.5 4.98332C14.725 4.70832 11.9333 4.56665 9.15 4.56665C7.5 4.56665 5.85 4.64998 4.2 4.81665L2.5 4.98332"
                        stroke="rgb(var(--locumate-clr-danger)"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.08331 4.14163L7.26665 3.04996C7.39998 2.25829 7.49998 1.66663 8.90831 1.66663H11.0916C12.5 1.66663 12.6083 2.29163 12.7333 3.05829L12.9166 4.14163"
                        stroke="rgb(var(--locumate-clr-danger)"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M15.7084 7.6167L15.1667 16.0084C15.075 17.3167 15 18.3334 12.675 18.3334H7.32502C5.00002 18.3334 4.92502 17.3167 4.83335 16.0084L4.29169 7.6167"
                        stroke="rgb(var(--locumate-clr-danger)"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.60834 13.75H11.3833"
                        stroke="rgb(var(--locumate-clr-danger)"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.91669 10.4166H12.0834"
                        stroke="rgb(var(--locumate-clr-danger)"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span>Remove Shift</span>
                  </el-button>
                  <el-button
                    type="transparent"
                    class="menu_item red"
                    v-if="
                      userRole === 'locum' &&
                      (shift.abilities.delete || shift.abilities.exit) &&
                      shift.status != 13
                    "
                     @click="isBlockShift=== 1 ? actions.bulkViewShifts(job,shift,i) : actions.openDialog(job, shift, i)"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M17.5 4.98332C14.725 4.70832 11.9333 4.56665 9.15 4.56665C7.5 4.56665 5.85 4.64998 4.2 4.81665L2.5 4.98332"
                        stroke="rgb(var(--locumate-clr-danger)"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.08331 4.14163L7.26665 3.04996C7.39998 2.25829 7.49998 1.66663 8.90831 1.66663H11.0916C12.5 1.66663 12.6083 2.29163 12.7333 3.05829L12.9166 4.14163"
                        stroke="rgb(var(--locumate-clr-danger)"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M15.7084 7.6167L15.1667 16.0084C15.075 17.3167 15 18.3334 12.675 18.3334H7.32502C5.00002 18.3334 4.92502 17.3167 4.83335 16.0084L4.29169 7.6167"
                        stroke="rgb(var(--locumate-clr-danger)"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M8.60834 13.75H11.3833"
                        stroke="rgb(var(--locumate-clr-danger)"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M7.91669 10.4166H12.0834"
                        stroke="rgb(var(--locumate-clr-danger)"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span>Remove Shift</span>
                  </el-button>
                  <el-button
                    type="transparent"
                    class="menu_item red"
                    v-if="userRole === 'pharmacy' && shift.status == 13"
                    @click="actions.goToGuestShiftDetails(shift, i)"
                    ><span
                      class="locumate_icons locumate_icon-remove_square"
                    ></span>
                    <span>It's a Guest Shift</span>
                  </el-button>
                  <div
                    v-else-if="
                      !(shift.abilities.delete || shift.abilities.exit)
                    "
                    type="transparent"
                    class="menu_item_reminder"
                  >
                    Please call {{ $filters.appName() }} on
                    {{ $filters.appContactNumber() }} or email
                    {{ $filters.appSupportEmail() }} to cancel this shift. A
                    cancellation fee is applicable for shifts cancelled within
                    72 hours of start time.
                  </div>
                </el-drawer>
              </div>
              <div class="actions" v-show="showActions[i]">
              <button
                class="delete-btn"
                v-show="showActions[i]"
                v-if="
                  userRole === 'pharmacy' &&
                  (shift.abilities.delete || shift.abilities.exit) &&
                  shift.status != 13
                "
                @click.prevent="isBlockShift=== 1 ? actions.bulkViewShifts(job,shift,i) : actions.openDialog(job, shift, i)"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.0702 5.23C19.4602 5.07 17.8502 4.95 16.2302 4.86V4.85L16.0102 3.55C15.8602 2.63 15.6402 1.25 13.3002 1.25H10.6802C8.35016 1.25 8.13016 2.57 7.97016 3.54L7.76016 4.82C6.83016 4.88 5.90016 4.94 4.97016 5.03L2.93016 5.23C2.51016 5.27 2.21016 5.64 2.25016 6.05C2.29016 6.46 2.65016 6.76 3.07016 6.72L5.11016 6.52C10.3502 6 15.6302 6.2 20.9302 6.73C20.9602 6.73 20.9802 6.73 21.0102 6.73C21.3902 6.73 21.7202 6.44 21.7602 6.05C21.7902 5.64 21.4902 5.27 21.0702 5.23Z"
                    fill="white"
                  />
                  <path
                    d="M19.2302 8.14C18.9902 7.89 18.6602 7.75 18.3202 7.75H5.68024C5.34024 7.75 5.00024 7.89 4.77024 8.14C4.54024 8.39 4.41024 8.73 4.43024 9.08L5.05024 19.34C5.16024 20.86 5.30024 22.76 8.79024 22.76H15.2102C18.7002 22.76 18.8402 20.87 18.9502 19.34L19.5702 9.09C19.5902 8.73 19.4602 8.39 19.2302 8.14ZM13.6602 17.75H10.3302C9.92024 17.75 9.58024 17.41 9.58024 17C9.58024 16.59 9.92024 16.25 10.3302 16.25H13.6602C14.0702 16.25 14.4102 16.59 14.4102 17C14.4102 17.41 14.0702 17.75 13.6602 17.75ZM14.5002 13.75H9.50024C9.09024 13.75 8.75024 13.41 8.75024 13C8.75024 12.59 9.09024 12.25 9.50024 12.25H14.5002C14.9102 12.25 15.2502 12.59 15.2502 13C15.2502 13.41 14.9102 13.75 14.5002 13.75Z"
                    fill="white"
                  />
                </svg>
              </button>

              <button
                class="delete-btn"
                v-show="showActions[i]"
                v-if="
                  userRole === 'locum' &&
                  (shift.abilities.delete || shift.abilities.exit) &&
                  shift.status != 13
                "
                @click.prevent="isBlockShift=== 1 ? actions.bulkViewShifts(job,shift,i) : actions.openDialog(job, shift, i)"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.0702 5.23C19.4602 5.07 17.8502 4.95 16.2302 4.86V4.85L16.0102 3.55C15.8602 2.63 15.6402 1.25 13.3002 1.25H10.6802C8.35016 1.25 8.13016 2.57 7.97016 3.54L7.76016 4.82C6.83016 4.88 5.90016 4.94 4.97016 5.03L2.93016 5.23C2.51016 5.27 2.21016 5.64 2.25016 6.05C2.29016 6.46 2.65016 6.76 3.07016 6.72L5.11016 6.52C10.3502 6 15.6302 6.2 20.9302 6.73C20.9602 6.73 20.9802 6.73 21.0102 6.73C21.3902 6.73 21.7202 6.44 21.7602 6.05C21.7902 5.64 21.4902 5.27 21.0702 5.23Z"
                    fill="white"
                  />
                  <path
                    d="M19.2302 8.14C18.9902 7.89 18.6602 7.75 18.3202 7.75H5.68024C5.34024 7.75 5.00024 7.89 4.77024 8.14C4.54024 8.39 4.41024 8.73 4.43024 9.08L5.05024 19.34C5.16024 20.86 5.30024 22.76 8.79024 22.76H15.2102C18.7002 22.76 18.8402 20.87 18.9502 19.34L19.5702 9.09C19.5902 8.73 19.4602 8.39 19.2302 8.14ZM13.6602 17.75H10.3302C9.92024 17.75 9.58024 17.41 9.58024 17C9.58024 16.59 9.92024 16.25 10.3302 16.25H13.6602C14.0702 16.25 14.4102 16.59 14.4102 17C14.4102 17.41 14.0702 17.75 13.6602 17.75ZM14.5002 13.75H9.50024C9.09024 13.75 8.75024 13.41 8.75024 13C8.75024 12.59 9.09024 12.25 9.50024 12.25H14.5002C14.9102 12.25 15.2502 12.59 15.2502 13C15.2502 13.41 14.9102 13.75 14.5002 13.75Z"
                    fill="white"
                  />
                </svg>
              </button>
            </div>
            </div>
          </template>
        </el-form-item>
        <el-form-item class="button_submit mb0 fixed-bottom-buttons">
          <template v-if="selectedApplicants.length === 0">
            <el-button class="submit_page w-full" type="grey" @click="goNext('dayForm')">
              Calendar View
            </el-button>
            <el-button
              v-if="
                job.shifts[0].applicationSelected == false && isBlockShift === 1 && job.shifts[0].shiftApplicationType !== 0
              "
              class="submit_page w-full"
              type="blue"
              @click="actions.bulkViewApplicants(job)"
            >
              View Applications
            </el-button>
          </template>
          <template
            v-else-if="isBlockShift === 0 && selectedApplicants.length !== 0"
          >
            <div class="offer-button-group">
              <el-button
                class="submit_page flex-1 primary"
                @click="actions.shiftOffer(job)"
              >
                Offer
              </el-button>
              <el-button
                class="submit_page flex-1 danger"
                @click="actions.bulkDecline(job)"
              >
                Decline
              </el-button>
            </div>
          </template>

          <el-button
            v-if="routeName == 'job_book_days'"
            class="submit_page"
            type="blue"
            @click="submit('dayForm')"
            :disabled="formsData.dayForm.disabled"
          >
            Accept
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="bg-overlay"></div>
  </div>
  <el-drawer
    custom-class="bottom_drop_up"
    v-model="moreBottomDropUp"
    :append-to-body="true"
    :with-header="false"
    :direction="'btt'"
    :destroy-on-close="true"
    data-testid="more-bottom-drop-up-drawer"
  >
    <div>
      <el-button
        class="d-block"
        @click="share(user)"
        data-testid="share-pharmacy-btn"
      >
        <i class="el-icon-share"></i> Share
      </el-button>
      <el-button
        class="ml-0 d-block"
        @click="blockPharmacy()"
        data-testid="block-unblock-pharmacy-btn"
      >
        <template v-if="job.blockedByLocum">
          <i class="el-icon-unlock mr-1 font-weight-bold"></i> Unblock Pharmacy
        </template>
        <template v-else>
          <i class="locumate_icons locumate_icon-denied mr-1"></i> Block
          Pharmacy
        </template>
      </el-button>
    </div>
  </el-drawer>
  <el-dialog
    modal-class="remove-shift-modal"
    v-if="dialog.dialogVisible"
    v-model="dialog.dialogVisible"
    :destroy-on-close="true"
    @close="actions.closeDialog"
    :title="`Shift for ${$moment(dialog.data.shift.date, 'YYYY/MM/DD').format(
      isAustralia ? 'dddd, D MMMM' : 'dddd, MMM D YYYY'
    )}`"
  >
    <div class="dialog-wrapper">
      <div
        class="cancel-message"
        v-if="bulkShiftListToShow.hasOwnProperty('shifts')"
      >
        Please note that this is a bulk shift. If you cancel this shift, all
        other shifts in the same job will also be removed. Following are the
        shifts that will be cancelled.
        <ul>
          <li v-for="shift in bulkShiftListToShow.shifts" :key="shift.id">
            {{ formatDate(shift.date) }} | {{ shift.startTime }} -
            {{ shift.endTime }}
          </li>
        </ul>
      </div>
      <span class="d-flex mb-1">Please choose your cancellation reason:</span>
      <div class="dialog-element">
        <el-select
          popper-class="normal-select"
          v-model="dialog.cancel.reasonType"
          placeholder="Choose an option"
        >
          <el-option
            v-for="item in dialog.cancel.options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>

      <div class="dialog-element" v-if="dialog.cancel.reasonType === 3">
        <el-input
          maxlength="255"
          show-word-limit
          v-model="dialog.cancel.description"
          :rows="4"
          type="textarea"
          placeholder="Please describe your situation"
        />
      </div>
      <div class="buttons-group">
        <button class="button" @click="actions.closeDialog">Cancel</button>
        <button
          class="button red"
          :disabled="removeButtonDisabled"
          @click="
            actions.removeShift(
              dialog.data.job,
              dialog.data.shift,
              dialog.data.i
            )
          "
        >
          Remove
        </button>
      </div>
    </div>
  </el-dialog>
  <modal-user-info
    :modalName="'userInfoModal'"
    :options="userInfoModal"
  ></modal-user-info>
  <modal-shift-edit
    v-if="userRole === 'pharmacy'"
    :modalName="'shiftEditModal'"
    :options="shiftEditModal"
  ></modal-shift-edit>
  <modal-applicants-view
    v-if="userRole === 'pharmacy'"
    :modalName="'ApplicationsModal'"
    :options="ApplicationsModal"
  ></modal-applicants-view>
  <modal-block-applicants-info
    v-if="userRole === 'pharmacy'"
    :modalName="'BlockApplicationsModal'"
    :options="BlockApplicationsModal"
  ></modal-block-applicants-info>
  <modal-agency-info
    :modalName="'agencyInfoModal'"
    :options="agencyInfoModal"
  ></modal-agency-info>
  <modal-block-shift-info
    
    :modalName="'BlockShiftModal'"
    :options="BlockShiftModal"
  ></modal-block-shift-info>
</template>

<script>
import { ElMessage, ElMessageBox } from "@/components/Vendor/Element";

import moment from "moment";

import { ref, onMounted, inject, computed, watch } from "vue";

import { addIcons } from "ionicons";
import { arrowBackOutline, ellipsisVerticalOutline } from "ionicons/icons";

addIcons({
  "arrow-back-outline": arrowBackOutline,
  "ellipsis-vertical-outline": ellipsisVerticalOutline,
});
import {
  IonToolbar,
  IonButton,
  IonButtons,
  IonIcon,
  // IonTitle,
} from "@ionic/vue";

import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";

const currentUrl = process.env.VUE_APP_CURRENT_URL;
import {
  UserInfoModal,
  ShiftEditModal,
  ApplicationsModal,
  BlockApplicationsModal,
  AgencyInfoModal,
  BlockShiftModal,
} from "@/modals/modals";
import timeDiff from "@/helpers/date/timeDiff";
import timeDiffAsDecimal from "@/helpers/date/timeDiffAsDecimal";
import ProgressBar from "./ProgressBar.vue";
import { vTouch } from "vue3-touch-events";
import { isAustraliaRegion, isUSRegion } from "@/helpers/region/regionHelper.js";
import distanceInMiles from "@/helpers/distance/distance-in-miles.js";


export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    // IonTitle,
    "modal-user-info": UserInfoModal,
    "modal-shift-edit": ShiftEditModal,
    "modal-applicants-view": ApplicationsModal,
    "modal-agency-info": AgencyInfoModal,
    "modal-block-applicants-info": BlockApplicationsModal,
    "modal-block-shift-info": BlockShiftModal,
    ProgressBar,
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const $moment = inject(["$moment"]);
    const setPageClassGlobal = inject("setPageClassGlobal");
    const $modals = inject("$modals");
    const message = inject("messages");
    const routeName = $route.name;
    const moreBottomDropUp = ref(false);
    const userData = $store.getters.GET_USER_DATA;
    const userRole = userData.role;
    const selectedApplicants = ref([]);
    const showActions = ref([]);
    const isAustralia = isAustraliaRegion();
    const isUS = isUSRegion();
    const setting = ref({});
    const activeNames = ref(["1"]);
    const bulkShiftListToShow = ref({});

    let job = ref($store.getters.getJobDetails.job);
    console.log("🚀 ~ file: Days.vue:649 ~ setup ~ job:", job);

    let shifts = computed(() => job.value.shifts);

    console.log('shifts', shifts.value);
    

    let isBlockShift = computed(() => job.value.isBlockShift);
    console.log("🚀 ~ setup ~ isBlockShift:", isBlockShift)

    watch(
      () => $store.getters.getJobDetails.job,
      (newJob) => {
        console.log("iamchengeddd", newJob);
        job.value = newJob;
      }
    );

    const bottomDropUp = ref([]);

    shifts.value.forEach((shift, i) => {
      bottomDropUp.value[i] = false;
    });
    const newJobData = computed(() => {
      return $store.getters.refreshJobData;
    });

    const activeCollapse = ref(""); // Holds the currently open collapse item's name

    // const openTitle = (shift) => {
    //   // Set the title for the open collapse item
    //   return isCollapeSelected(shift.id) ? 'Close' : 'Open';
    // };

    // const isCollapeSelected = () => {
    //   // Logic to check if an item is selected
    //   return true; // Replace with your logic
    // };

    // watch(selectedApplicants, (newSelectedApplicants, oldSelectedApplicants) => {
    //   console.log("🚀 ~ file: Days.vue:628 ~ watch ~ oldSelectedApplicants:", oldSelectedApplicants)
    //   // Perform additional logic when selectedApplicants changes
    //   console.log('Selected Applicants:', newSelectedApplicants);
    // });

    const isSelected = (applicantId) => {
      return selectedApplicants.value.includes(applicantId);
    };

    const handleCheckboxChange = (applicantId) => {
      const index = selectedApplicants.value.indexOf(applicantId);
      if (index === -1) {
        selectedApplicants.value.push(applicantId);
      } else {
        selectedApplicants.value.splice(index, 1);
      }
    };
    // Check if selectedApplicants contains at most one shift application id for each shift
    const isValidSelect = () => {
      var shiftsAssigned = [];
      shifts.value.forEach((jobShift) => {
        var shiftId = jobShift.id;
        var shiftApplicationIds = jobShift.shiftApplications.map(
          (applicant) => {
            return applicant.id;
          }
        );

        var shiftApp = selectedApplicants.value.filter((shiftApplicantId) => {
          return shiftApplicationIds.includes(shiftApplicantId);
        });
        shiftsAssigned.push({ id: shiftId, shiftassigned: shiftApp.length });
      });
      return shiftsAssigned;
    };

    const goToJobApplicants = (shiftId) => {
      $router.push({
        name: "shift_applicants",
        params: {
          shiftId: shiftId,
        },
      });
    };

    const formsDataArray = {
      dayForm: {
        jobShifts: {
          value: shifts,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "jobShiftsBook",
                  callback,
                  setFormValidation
                );
              },
            },
          ],
        },
      },
    };

    const checkJobDateStart = (dateStart, endDate, trim) => {
      let start = moment(dateStart, "YYYY/MM/DD");
      let end = moment(endDate, "YYYY/MM/DD");
      if (start.format("MMMM") == end.format("MMMM")) {
        if (start.format("D") == end.format("D")) {
          return start.format("D " + (trim ? "MMM" : "MMMM"));
        }
        return (
          start.format("D ") +
          " - " +
          end.format("D " + (trim ? "MMM" : "MMMM"))
        );
      } else {
        return (
          start.format("D " + (trim ? "MMM" : "MMMM")) +
          " - " +
          end.format("D " + (trim ? "MMM" : "MMMM"))
        );
      }
    };

    const getSelectedShiftsId = () => {
      return shifts.value
        .filter((day) => {
          if (day.checkboxValue == true) {
            return true;
          }
        })
        .map((day) => day.id);
    };

    let featureShiftsMark = false;
    const featureShiftsMarkArray = ref([]);
    const pastShiftsMark = ref(false);

    const breakTimeFormat = (shift) => {
      let shiftBreakTime = shift.userBreakMinutes;
      if (Math.floor(shiftBreakTime / 60)) {
        return moment(
          Math.floor(shiftBreakTime / 60) + ":" + (shiftBreakTime % 60),
          ["h:m"]
        ).format("H:mm");
      } else {
        return moment(shiftBreakTime % 60, ["m"]).format("m");
      }
    };
    const formatHourlyRate = (regularRate, weekendRate) => {
      if (
        job.value.shifts.length === 1 &&
        job.value.shifts[0].payRateExecSuper
      ) {
        return new Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(
          job.value.shifts[0].payRate - job.value.shifts[0].payRateSuper
        );
      }
      let formattedString = "";
      formattedString += regularRate ? formatCurrency(regularRate) : "";
      formattedString += regularRate && weekendRate ? " - " : "";
      formattedString += weekendRate ? formatCurrency(weekendRate) : "";

      return formattedString;
    };

    const formatCurrency = (rate) => {
      return new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
      }).format(rate);
    };

    const bottomDropUpExist = () => {
      return true;
    };

    const bottomDropUpClose = (i) => {
      bottomDropUp.value[i] = false;
    };

    const shiftEditModal = ref({
      name: "shiftEdit",
      job: {},
      shift: {},
    });

    const ApplicationsModal = ref({
      name: "viewApplicants",
      job: {},
      shift: {},
    });

    const BlockApplicationsModal = ref({
      name: "bulkViewApplicants",
      job: {},
    });

    const BlockShiftModal = ref({
      name: "bulkViewShifts",
      job: {},
    });

    const shiftEditModalOpen = (job, shift) => {
      
      shiftEditModal.value.job = job;
      shiftEditModal.value.shift = shift;
      $modals.open("shiftEditModal");
    };

    const applicantViewModalOpen = (job, shift) => {
      ApplicationsModal.value.job = job;
      ApplicationsModal.value.shift = shift;
      $modals.open("ApplicationsModal");
    };
    const blockApplicantViewModalOpen = (job) => {
      BlockApplicationsModal.value.job = job;
      $modals.open("BlockApplicationsModal");
    };
    const blockShiftViewModalOpen = (job,shift,i) => {
      console.log("hello clocke", i);
      BlockShiftModal.value.job = job;
      BlockShiftModal.value.selectedShift = shift;
      BlockShiftModal.value.i = i;
      $modals.open("BlockShiftModal");
    };

    const dialog = ref({
      dialogVisible: false,
      data: {},
      cancel: {
        reasonType: null,
        options: [
          { label: "Change in availability", value: 1 },
          { label: "Other...", value: 3 },
        ],
        description: null,
      },
    });
    const getCancellationReason = () => {
      if (dialog.value.cancel.reasonType === 3) {
        return dialog.value.cancel.description;
      }
      return dialog.value.cancel.options[dialog.value.cancel.reasonType - 1]
        .label;
    };

    const removeButtonDisabled = computed(() => {
      if (
        dialog.value.cancel.reasonType &&
        dialog.value.cancel.reasonType !== 3
      )
        return false;
      if (
        dialog.value.cancel.reasonType === 3 &&
        dialog.value.cancel.description
      )
        return false;
      return true;
    });

    const actions = {
      editShift(job, shift, i) {
        console.log("job", job);
        console.log("shift", shift);
        bottomDropUpClose(i);
        shiftEditModalOpen(job, shift);
      },
      viewApplicants(job, shift, i) {
        console.log("hello clocke");
        bottomDropUpClose(i);
        applicantViewModalOpen(job, shift);
      },
      bulkViewApplicants(job) {
        console.log("hello clocke");
        blockApplicantViewModalOpen(job);
      },
      bulkViewShifts(job,shift,i) {
        console.log("hello sssclocke",job);
        bottomDropUpClose(i);
        blockShiftViewModalOpen(job,shift,i);
      },
      shiftOffer(job) {
        console.log("asdsadadsadsadsad", isValidSelect());
        const isValidselectedApp =
          isValidSelect().filter((item) => item.shiftassigned > 1).length > 0;

        if (isValidselectedApp) {
          ElMessageBox.alert(
            "Multiple applicants have been assigned to a single shift. Please review and correct the assignment.",
            "Error",
            {
              showCancelButton: false,
              confirmButtonText: "Close",
              confirmButtonClass: "el-button--red",
            }
          );
        } else {
          (async () => {
            try {
              await ElMessageBox.confirm(
                `Are you sure you'd like to offer shift(s) to selected applicant(s)?`,
                "Offer Shift",
                {
                  confirmButtonText: "Offer",
                  cancelButtonText: "Cancel",
                  confirmButtonClass: "el-button--blue",
                  cancelButtonClass: "secondary",
                  showClose: false,
                }
              );
              await (async () => {
                try {
                  await $store.dispatch("BULK_OFFER", {
                    application_ids: selectedApplicants.value,
                  });

                  const jobResponse = await $store.dispatch(
                    "GET_JOB_INFO_DETAILS",
                    {
                      jobId: job.id,
                      params: {
                        with: "pharmacy,pharmacy.settings,pharmacy.address,pharmacy.files,locum,locum.settings,locum.address,shifts.pharmacy,shifts.pharmacy.settings,shifts.pharmacy.address,shifts.pharmacy.files,shifts.locum,shifts.locum.settings,shifts.locum.address,abilities,config.hours_before_shift_lock,settings,agency,shifts.agency, shifts.shiftApplications",
                      },
                    }
                  );
                  console.log(
                    "🚀 ~ file: ApplicationsPreviewModal.vue:251 ~ await ~ job:",
                    jobResponse
                  );

                  $store.dispatch("clearJobDetails");
                  $store.dispatch("setJobDetails", {
                    job: jobResponse.data,
                  });

                  ElMessage({
                    type: "success",
                    message: "All Applicants offered successfully",
                  });
                  selectedApplicants.value = [];
                } catch (error) {
                  ElMessage({
                    type: "info",
                    message: "All Applicants did not offered",
                  });
                  console.log("error submit!!", error);
                }
              })();
            } catch (error) {
              console.log(error);
            }
          })();
        }
      },
      bulkDecline(job) {
        let startDate = checkJobDateStart(job.startDate, job.endDate, true);
        // let endDate = $moment(job.endDate, "YYYY/MM/DD").format("D MMM");
        let popUpTitle = null;
        let content = null;
        if (selectedApplicants.value.length > 1) {
          popUpTitle = "Decline Bulk Applicants";
          content = `Are you sure you’d like to decline bulk applicants for ${startDate} shift.`;
        } else {
          popUpTitle = "Decline Applicant";
          content = `Are you sure you’d like to decline applicant for ${startDate} shift.`;
        }
        (async () => {
          try {
            await ElMessageBox.confirm(content, popUpTitle, {
              confirmButtonText: "Decline",
              cancelButtonText: "Cancel",
              confirmButtonClass: "danger",
              cancelButtonClass: "secondary",
              showClose: false,
            });
            await (async () => {
              try {
                await $store.dispatch("BULK_DECLINE", {
                  application_ids: selectedApplicants.value,
                });

                const jobResponse = await $store.dispatch(
                  "GET_JOB_INFO_DETAILS",
                  {
                    jobId: job.id,
                    params: {
                      with: "pharmacy,pharmacy.settings,pharmacy.address,pharmacy.files,locum,locum.settings,locum.address,shifts.pharmacy,shifts.pharmacy.settings,shifts.pharmacy.address,shifts.pharmacy.files,shifts.locum,shifts.locum.settings,shifts.locum.address,abilities,config.hours_before_shift_lock,settings,agency,shifts.agency, shifts.shiftApplications",
                    },
                  }
                );
                console.log(
                  "🚀 ~ file: ApplicationsPreviewModal.vue:251 ~ await ~ job:",
                  jobResponse
                );

                $store.dispatch("clearJobDetails");
                $store.dispatch("setJobDetails", {
                  job: jobResponse.data,
                });

                ElMessage({
                  type: "success",
                  message: "Applicant(s) has been declined",
                });
                selectedApplicants.value = [];
              } catch (error) {
                ElMessage({
                  type: "info",
                  message: "All Applicants did not declined",
                });
                console.log("error submit!!", error);
              }
            })();
          } catch (error) {
            console.log(error);
          }
        })();
      },
      removeApplicants(job, shift, i) {
        console.log(
          "🚀 ~ file: Days.vue:667 ~ removeApplicants ~ job:",
          job.id
        );
        bottomDropUpClose(i);
        (async () => {
          try {
            await ElMessageBox.confirm(
              `Are you sure you’d like to remove ${
                shift.applicationSelectedBy.locum.name
              } applicant for ${$moment(shift.date, "YYYY/MM/DD").format(
                "D MMM, YYYY"
              )} shift.`,
              "Remove applicant",
              {
                confirmButtonText: "Remove",
                cancelButtonText: "Cancel",
                confirmButtonClass: "el-button--red",
                cancelButtonClass: "el-button--grey",
                showClose: false,
              }
            );
            await (async () => {
              try {
                await $store.dispatch("WITHDRAW_APPLICANT_BY_PHARMACY", {
                  application_id: shift.applicationSelectedBy.id,
                });

                const jobResponse = await $store.dispatch(
                  "GET_JOB_INFO_DETAILS",
                  {
                    jobId: job.id,
                    params: {
                      with: "pharmacy,pharmacy.settings,pharmacy.address,pharmacy.files,locum,locum.settings,locum.address,shifts.pharmacy,shifts.pharmacy.settings,shifts.pharmacy.address,shifts.pharmacy.files,shifts.locum,shifts.locum.settings,shifts.locum.address,abilities,config.hours_before_shift_lock,settings,agency,shifts.agency, shifts.shiftApplications",
                    },
                  }
                );
                console.log(
                  "🚀 ~ file: ApplicationsPreviewModal.vue:251 ~ await ~ job:",
                  jobResponse
                );

                $store.dispatch("clearJobDetails");
                $store.dispatch("setJobDetails", {
                  job: jobResponse.data,
                });

                ElMessage({
                  type: "success",
                  message: "Applicant removed successfully",
                });
              } catch (error) {
                ElMessage({
                  type: "info",
                  message: "Applicant did not removed",
                });
                console.log("error submit!!", error);
              }
            })();
            bottomDropUpClose(i);
          } catch (error) {
            console.log(error);
          }
        })();
      },
      async openDialog(job, shift, i) {
        console.log("hshshshshshs",shift );
        if (job?.isBlockShift == 1) {
          let response = await $store.dispatch("GET_BLOCK_SHIFT_SHIFTS", {
            shiftId: shift.id,
            params: { 
              with: "settings",
            }
          });

          bulkShiftListToShow.value = response.data;

          
        }
        dialog.value.dialogVisible = true;
        dialog.value.data = { job, shift, i };
      },
      closeDialog() {
        dialog.value.dialogVisible = false;
        dialog.value.cancel.reasonType = null;
        dialog.value.cancel.description = null;
      },
      removeShift(job, shift, i) {
        (async () => {
          try {
            // await ElMessageBox.confirm(
            //   `Are you sure you’d like to remove shift for ${$moment(
            //     shift.date,
            //     "YYYY/MM/DD"
            //   ).format("D MMM, YYYY")}`,
            //   "Remove shift",
            //   {
            //     confirmButtonText: "Remove",
            //     cancelButtonText: "Cancel",
            //     confirmButtonClass: "el-button--red danger",
            //     cancelButtonClass: "el-button--grey secondary",
            //     showClose: false,
            //   }
            // );
            let formattedDates = null;
            if (job.isBlockShift == 1) {
              let response = await $store.dispatch("GET_BLOCK_SHIFT_SHIFTS", {
                shiftId: shift.id,
              });

              formattedDates = response.data.shifts
                .map((shift) =>
                  $moment(shift.date, "YYYY-MM-DD").format("D MMM YYYY")
                )
                .join(", ");
            }

            (async () => {
              try {
                console.log("Shifts: ", bulkShiftListToShow.value);
                if (job.isBlockShift == 1) {
                  let alertMessageHtml = `Are you sure you’d like to remove shifts for following ${formattedDates} dates?`;
                  if (bulkShiftListToShow.value.shifts.length > 1) {
                    alertMessageHtml = `<div class="cancel-message">
                  Please note that this is a bulk shift. If you cancel this shift, all other shifts in the same job will also be removed. Following are the shifts that will be cancelled.
                  <ul>`;
                    bulkShiftListToShow.value.shifts.forEach((shift) => {
                      alertMessageHtml += `<li>${formatDate(shift.date)} | ${
                        shift.startTime
                      } - ${shift.endTime}</li>`;
                    });
                    alertMessageHtml += `</ul></div>`;
                  }
                  await ElMessageBox.confirm(
                    // `Are you sure you’d like to remove shifts for ${formattedDates}?`,
                    alertMessageHtml,
                    "Remove shift",
                    {
                      confirmButtonText: "Remove",
                      cancelButtonText: "Cancel",
                      confirmButtonClass: "el-button--red",
                      cancelButtonClass: "el-button--grey",
                      showClose: false,
                      dangerouslyUseHTMLString: true,
                      customClass: "remove-shift-confirm-modal",
                    }
                  );
                } else {
                  await ElMessageBox.confirm(
                    `Are you sure you’d like to remove shift for ${$moment(
                      shift.date,
                      "YYYY/MM/DD"
                    ).format("D MMM, YYYY")}`,
                    "Remove shift",
                    {
                      confirmButtonText: "Remove",
                      cancelButtonText: "Cancel",
                      confirmButtonClass: "el-button--red",
                      cancelButtonClass: "el-button--grey",
                      showClose: false,
                    }
                  );
                }
                const reason = getCancellationReason();
                console.log(reason);

                await (async () => {
                  try {
                    if (userRole == "locum") {
                      await $store.dispatch("EXIT_SHIFT", {
                        shiftId: shift.id,
                        reason: reason,
                      });
                      dialog.value.dialogVisible = false;
                    } else {
                      await $store.dispatch("DELETE_SHIFT", {
                        shiftId: shift.id,
                        reason: reason,
                      });
                    }

                    ElMessage({
                      type: "success",
                      message: "Shift removed successfully",
                    });
                    dialog.value.dialogVisible = false;
                    // fillCalendarMonth(true);
                    shifts.value.splice(i, 1);

                    if (
                      (userRole == "pharmacy" && shifts.value.length == 0) ||
                      (userRole == "pharmacy" && job.isBlockShift == 1)
                    ) {
                      $router.push({
                        name: "search",
                      });
                    }
                  } catch (error) {
                    ElMessage({
                      type: "info",
                      message: "Shift did not removed",
                    });
                    console.log("error submit!!");
                  }
                })();
                bottomDropUpClose(i);
              } catch (error) {
                console.log(error);
              }
            })();
          } catch (error) {
            console.log("error submit!!", error);
          }
        })();
      },
      goToGuestShiftDetails(shift, i) {
        console.log("bedor clicking shift", shift);
        bottomDropUpClose(i);
        $router.push({
          name: "guest_shift_details",
          params: {
            shiftId: shift.guestId,
          },
        });
      },
    };

    const userInfoModal = ref({
      name: "userInfo",
      user: {},
    });

    const agencyInfoModal = ref({
      name: "agencyInfo",
      user: {},
    });

    const userInfoModalOpen = (user) => {
      if (user && user !== 'pharmacy') {
        userInfoModal.value.user = user;
      } else {
        userInfoModal.value.user = job.value.pharmacy;
      }

      $modals.open("userInfoModal");
    };

    const agnecyInfoModalOpen = (user) => {
      agencyInfoModal.value.user = user;
      $modals.open("agencyInfoModal");
    };

    const goToJobCalendar = (shift) => {
      $router.push({
        name: "job_calendar",
        params: {
          date: shift.date,
        },
      });
    };

    const goBack = () => {
      $router.push({
        name: $store.getters["getPageBack"]({
          state: "job",
          remove: true,
        }).name,
        params: {
          date: $store.getters.getJobDetails.date,
        },
      });
    };

    const goNext = () => {
      $store.dispatch("setJobDetails", {
        job: job.value,
      });
      $router.push({
        name: "job_calendar",
        params: {
          date: $route.params.date || null,
        },
      });
    };

    const submit = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          (async () => {
            try {
              await $store.dispatch("SAVE_JOB_SHIFTS_LIST", {
                shifts_ids: getSelectedShiftsId(),
              });
              ElMessage({
                type: "success",
                message: "Thank you for booking the shift.",
              });
              $router.push({
                name: "search",
              });
            } catch (error) {
              console.log("error submit!!");
            }
          })();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };

    const handleClick = (shift) => {

      if (userRole === "pharmacy") {
        if (shift.locum) {
          userInfoModalOpen(shift.locum);
        } else if (shift.status === 14) {
          console.log('I am agency users');
          
          agnecyInfoModalOpen(shift.agency);
        } else {
          return false;
        }
      }
    };

    onMounted(() => {
      setPageClassGlobal("global_job_book_page");
      setFormRefs();
      checkFormValidation("dayForm", false);
      const touchEvents = vTouch({
        swipe: {
          threshold: 15, // Adjust the swipe threshold if needed
        },
      });
      touchEvents.install(); // Install the touch events
      shifts.value.forEach((shift) => {
        if (
          !moment(shift.date, "YYYY-MM-DD").isBefore(new Date(), "day") &&
          !featureShiftsMark
        ) {
          featureShiftsMark = true;
          featureShiftsMarkArray.value.push(true);
        } else featureShiftsMarkArray.value.push(false);

        if (
          moment(shift.date, "YYYY-MM-DD").isBefore(new Date(), "day") &&
          !pastShiftsMark.value
        ) {
          pastShiftsMark.value = true;
        }
      });
    });
    const confirmedHours = (confirmedHours, startTime, endTime) => {
      let result;
      if (confirmedHours == 0) {
        const start = moment(startTime, "HH:mm:ss");
        const end = moment(endTime, "HH:mm:ss");

        result = timeDiff(start, end);
      } else {
        const string = String(confirmedHours);
        const hours = string.split(".")[0];
        let minutes = string.split(".")[1];
        if (!minutes) {
          const time = hours + ":" + "00";
          result = String(time);
        } else {
          minutes = Number.parseFloat(`0.${minutes}`) * 60;
          result = hours + ":" + minutes.toFixed(0);
        }
      }

      return result;
    };
    const Sum = (shift) => {
      const globalTravelCompensationValue =
        process.env.VUE_APP_TRAVEL_COMPENSATION;

      let Sum;
      let confirmedHoursVal;
      let payRate;
      let travelCompensation;
      if (userRole === "locum") {
        if (shift.locum == null && shift.payRateExecSuper == null) {
          payRate = shift.recommendedRate;
        } else {
          payRate = shift.payRateExecSuper;
        }
      } else {
        payRate = shift.payRateExecSuper;
      }
      if (shift.confirmedHours == 0 || shift.confirmedHours == null) {
        const start = moment(shift.startTime, "HH:mm:ss");
        const end = moment(shift.endTime, "HH:mm:ss");

        confirmedHoursVal = timeDiffAsDecimal(start, end);
      } else {
        confirmedHoursVal = shift.confirmedHours;
      }

      if (
        shift.travelCompensation === 0 &&
        shift.adminUpdatedTravelCompensation == false
      ) {
        let jobDistance = shift.distance ? shift.distance : null;
        // const jobDistance = job.value.distance.replace(',', '.').split(" ")[0];

        if (jobDistance === null && job.value.distance) {
          jobDistance = job.value.distance;
        }

        if (jobDistance) {
          let distance = jobDistance;

          if (job.value.settings.payingForTravel == 1) {
            if (distance * 2 > 50) {
              travelCompensation =
                (distance * 2 - 50) * globalTravelCompensationValue;
            } else {
              travelCompensation = shift.travelCompensation;
            }
          } else if (job.value.settings.payingForTravel == 2) {
            travelCompensation = distance * 2 * globalTravelCompensationValue;
          } else if (
            job.value.settings.payingForTravel === 3 &&
            job.value.maxTravelCompensation !== 0
          ) {
            let realTravelCost = distance * 2 * globalTravelCompensationValue;
            if (realTravelCost > job.value.maxTravelCompensation) {
              travelCompensation = job.value.maxTravelCompensation;
            } else {
              travelCompensation = distance * 2 * globalTravelCompensationValue;
            }
          }
        } else {
          travelCompensation = shift.travelCompensation;
        }

        if (!job.value.settings.payingForTravel) {
          travelCompensation = 0;
        }
      } else {


        if(!shift.shiftBookedAsInternalStaff ||
                          shift.isVisibileAsInternalLocum === false){
          
          travelCompensation = shift.travelCompensation;
        } else {
          travelCompensation = 0;
        }
      }

      // if (!job.value.settings.payingForTravel) {
      //   travelCompensation = 0;
      // }

      if (payRate != null) {
        Sum = payRate * confirmedHoursVal + travelCompensation;
      } else {
        Sum = 0;
      }

      if (Sum != 0) {
        Sum = new Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(Sum);
      } else {
        Sum = "-";
      }

      return Sum;
    };

    const Rate = (shift) => {
      if (userRole === "pharmacy") {
        return shift.payRateExecSuper
          ? new Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(shift.payRateExecSuper)
          : "-";
      }else if(userRole == "agency"){
        return shift.shiftAgencyLocum.rate
          ? new Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(shift.shiftAgencyLocum.rate)
          : "-";
      } else {
        if (shift.locum == null && shift.payRateExecSuper == null) {
          return Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(shift.recommendedRate);
        } else {
          return Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(shift.payRateExecSuper);
        }
      }
    };

    const SuperRate = (shift) => {
      if (userRole === "pharmacy") {
        return shift.payRateSuper
          ? new Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(shift.payRateSuper)
          : "-";
      } else {
        if (shift.locum == null) {
          return "-";
        } else {
          return Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(shift.payRateSuper);
        }
      }
    };

    const totalSuperRate = (shift) => {
      let confirmedHoursVal = 0;

      if (shift.confirmedHours == 0 || shift.confirmedHours == null) {
        const start = moment(shift.startTime, "HH:mm:ss");
        const end = moment(shift.endTime, "HH:mm:ss");

        confirmedHoursVal = timeDiffAsDecimal(start, end);
      } else {
        confirmedHoursVal = shift.confirmedHours;
      }

      const superRate = shift.payRateSuper * confirmedHoursVal;

      return superRate
        ? Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(superRate)
        : "-";
    };

    const distance = (job, shift) => {
      let result;
      const globalTravelCompensationValue =
        process.env.VUE_APP_TRAVEL_COMPENSATION;
      if (!shift.distance && !job.distance && !shift.historyDistance) {
        result = "-";
      } else {
        let distance;
        distance = shift.historyDistance ? shift.historyDistance : job.distance;

        if (job.settings.payingForTravel == 1) {
          if (distance * 2 > 50) {
            const result1 = (distance * 2 - 50) * globalTravelCompensationValue;
            result = new Intl.NumberFormat("en-AU", {
              style: "currency",
              currency: "AUD",
            }).format(result1);
          } else {
            result = "-";
          }
        } else if (job.settings.payingForTravel == 2) {
          result = new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(distance * 2 * globalTravelCompensationValue);
        } else if (job.settings.payingForTravel == 3) {
          result = new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(job.maxTravelCompensation);
        }
      }
      return result;
    };

    const formatHourlyRatePharmacy = () => {
      const rateArray = [];

      if (
        job.value.shifts.length === 1 &&
        job.value.shifts[0].payRateExecSuper
      ) {
        return new Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(
          job.value.shifts[0].payRate - job.value.shifts[0].payRateSuper
        );
      }

      if (job.value.recommendedRatesString) {
        return job.value.recommendedRatesString;
      }

      if (job.value.minRate) {
        rateArray.push(job.value.minRate);
      }
      if (job.value.maxRate) {
        rateArray.push(job.value.maxRate);
      }
      if (job.value.weekendMaxRate) {
        rateArray.push(job.value.weekendMaxRate);
      }
      if (job.value.weekendMinRate) {
        rateArray.push(job.value.weekendMinRate);
      }
      if (job.value.saturdayMinRate) {
        rateArray.push(job.value.saturdayMinRate);
      }
      if (job.value.saturdayMaxRate) {
        rateArray.push(job.value.saturdayMaxRate);
      }
      if (job.value.sundayMinRate) {
        rateArray.push(job.value.sundayMinRate);
      }
      if (job.value.sundayMaxRate) {
        rateArray.push(job.value.sundayMaxRate);
      }

      rateArray.sort((a, b) => a - b);
      const firstEl = rateArray.shift();
      const lastEl = rateArray.pop();
      return (
        new Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(firstEl) +
        " - " +
        new Intl.NumberFormat("en-AU", {
          style: "currency",
          currency: "AUD",
        }).format(lastEl)
      );
    };

    const getTimeFromMinutes = (mins) => {
      if (mins >= 24 * 60 || mins < 0) {
        throw new RangeError(
          "Valid input should be greater than or equal to 0 and less than 1440."
        );
      }
      var h = (mins / 60) | 0,
        m = mins % 60 | 0;

      return moment.utc().hours(h).minutes(m).format("HH:mm");
    };
    const share = () => {
      moreBottomDropUp.value = false;
      const link = currentUrl + "job-preview/" + job.value.id;
      const el = document.createElement("textarea");
      el.value = link;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      ElMessageBox.alert("Link to current job copied to clipboard", "Thanks", {
        type: "success ",
        showCancelButton: false,
        confirmButtonText: "Close",
        callback: () => {},
      });
    };

    const blockPharmacy = () => {
      moreBottomDropUp.value = false;
      const isPharmacyBlocked = job.value.blockedByLocum;
      const type = isPharmacyBlocked ? "unblock" : "block";
      let title = isPharmacyBlocked
        ? "Are you sure you want to unblock this pharmacy?"
        : "Are you sure you want to block this pharmacy?";
      let message = isPharmacyBlocked
        ? ""
        : "You will no longer see their shifts";
      ElMessageBox.confirm(message, title, {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      })
        .then(() => {
          $store
            .dispatch("BLOCK_PHARMACY", {
              pharmacyId: job.value.pharmacyId,
              type: type,
            })
            .then(() => {
              ElMessage({
                type: "success",
                message: `Pharmacy ${type}ed successfully`,
              });
              goBack();
            });
        })
        .catch(() => {});
    };

    const showShiftInformation = (shift) => {
      if (userRole === "pharmacy") return true;
      if (
        shift?.job?.isInternalStaffOfThisPharmacy &&
        shift.shiftSubscription
      ) {
        return false;
      }
      if (!shift.userId) return true;
      if (shift.userId === userData.id) return true;
      return false;
    };

    const adminChangedTravelComp = (shift) => {
      if (shift.adminUpdatedTravelCompensation == true) {
        return true;
      } else {
        return false;
      }
    };

    const travelCompensationCount = (job, shift) => {
      
      let travelCompensation = calculateTravelCompensation(job, shift); // Call the original function

      // Admin-set per-shift travel must show on every day, not only first/last when job uses that mode
      if (adminChangedTravelComp(shift)) {
        return travelCompensation;
      }
     
      // For pharmacy if shift is not taken by anyone then show job max travel compensation instead of travel compensation after accepted by locum
      if(shift.status === 0 && userRole === 'pharmacy') {
        let maxTravelCompensation = job.maxTravelCompensation;
       
        let enableTravelAllowanceForFirstAndLastDay = job.enableTravelAllowanceForFirstAndLastDay;
        if(enableTravelAllowanceForFirstAndLastDay == 1){
          if(!isNaN(maxTravelCompensation)){//is numeric
            maxTravelCompensation = maxTravelCompensation / 2;
          }
          if (shift.date !== job.startDate && shift.date !== job.endDate) {
            maxTravelCompensation = 0;
          }
         
         
        }
        return new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(maxTravelCompensation);
      }
      //check if is not numeric travelCompensation retuirn -
      if (isNaN(parseFloat(travelCompensation.replace(/[^0-9.-]+/g, "")))) {
        return "-";
      }
      if (job.enableTravelAllowanceForFirstAndLastDay === 1) {
        // const shiftsLength = job.shifts.length;
        // const isFirstShift = i === 0;
        // const isLastShift = i === shiftsLength - 1;

        let numericValue = parseFloat(travelCompensation.replace(/[^0-9.-]+/g, ""));

          // from backend in pharmacy side we are getting the travel compensation as half of the value already after accepted by locum from adminUpdatedTravelCompensation
          let halfCompensation = numericValue ;
          if(shift.status === 0){
            halfCompensation = numericValue / 2;
          }

          if (shift.date !== job.startDate && shift.date !== job.endDate) {
            halfCompensation = 0;
          }

          // Format back to currency using Intl.NumberFormat
          return new Intl.NumberFormat("en-AU", {
            style: "currency",
            currency: "AUD",
          }).format(halfCompensation);
      }

      return travelCompensation; // Default behavior
    };

    // const travelCompensationCount = (job, shift) => {
    //   if (
    //     (shift.travelCompensation >= 0 &&
    //       shift.adminUpdatedTravelCompensation == true) ||
    //     (shift.travelCompensation === 0 &&
    //       shift.adminUpdatedTravelCompensation == true)
    //   ) {
    //     const convertedTravelRate = formatCurrency(shift.travelCompensation);
    //     return convertedTravelRate;
    //   } else {
    //     if (
    //       job.settings.payingForTravel === 0 &&
    //       shift.adminUpdatedTravelCompensation == false
    //     ) {
    //       return "-";
    //     }
    //   }

    //   if (
    //     job.settings.payingForTravel === 3 &&
    //     job.maxTravelCompensation !== 0
    //   ) {
    //     let travelCompensation;

    //     //admin may change the travel compensation for the job via job menu in the admin panel
    //     //the changed travel compensation only reflects on the shifts that has not been booked
    //     //so to keep track of previous travel compensations, we store the travel compensation in the shift table as well naming the column as job_max_travel_compensation
    //     //job_max_travel_compensation in the shift table is updated when admin updates the travel compensation for the job
    //     //where the shifts job_max_travel_compensation that has been booked is updated with previous travel compensation and the shifts that has not been booked is updated with the new travel compensation
    //     let maxTravelCompensation = shift.jobMaxTravelCompensation && shift.userId ? shift.jobMaxTravelCompensation : job.maxTravelCompensation;
    //     const globalTravelCompensationValue = process.env.VUE_APP_TRAVEL_COMPENSATION;
    //     const jobDistance = shift.distance ? shift.distance : null;

    //     if (jobDistance) {
    //       let distance = jobDistance;
    //       travelCompensation = distance * 2 * globalTravelCompensationValue;
    //       if (travelCompensation > maxTravelCompensation) {
    //         const convertedTravelRate = formatCurrency(maxTravelCompensation);
    //         return convertedTravelRate;
    //       } else {
    //         travelCompensation = new Intl.NumberFormat("en-AU", {
    //           style: "currency",
    //           currency: "AUD",
    //         }).format(distance * 2 * globalTravelCompensationValue);
    //         return travelCompensation;
    //       }
    //     } else {
    //       const convertedTravelRate = formatCurrency(maxTravelCompensation);
    //       return convertedTravelRate;
    //     }
    //   } else {
    //     const convertedTravelRate = formatCurrency(+shift.travelCompensation);
    //     return convertedTravelRate;
    //   }
    // };

    const calculateTravelCompensation = (job, shift) => {
      if (!job.isInternalStaffOfThisPharmacy && job.isVisibileAsInternalLocum === false) {
        if (
          (shift.travelCompensation >= 0 &&
            shift.adminUpdatedTravelCompensation == true) ||
          (shift.travelCompensation === 0 &&
            shift.adminUpdatedTravelCompensation == true)
        ) {
          const convertedTravelRate = formatCurrency(shift.travelCompensation);
          return convertedTravelRate;
        }else if(shift.travelCompensation >= 0 ){
          const convertedTravelRate = formatCurrency(shift.travelCompensation);
          return convertedTravelRate;
        } else {
          if (
            job.settings.payingForTravel === 0 &&
            shift.adminUpdatedTravelCompensation == false
          ) {
            return "-";
          }
        }

        if (
          job.settings.payingForTravel === 3 &&
          job.maxTravelCompensation !== 0
        ) {
          let travelCompensation;

          //admin may change the travel compensation for the job via job menu in the admin panel
          //the changed travel compensation only reflects on the shifts that has not been booked
          //so to keep track of previous travel compensations, we store the travel compensation in the shift table as well naming the column as job_max_travel_compensation
          //job_max_travel_compensation in the shift table is updated when admin updates the travel compensation for the job
          //where the shifts job_max_travel_compensation that has been booked is updated with previous travel compensation and the shifts that has not been booked is updated with the new travel compensation
          let maxTravelCompensation =
            shift.jobMaxTravelCompensation && shift.userId
              ? shift.jobMaxTravelCompensation
              : job.maxTravelCompensation;
          const globalTravelCompensationValue =
            process.env.VUE_APP_TRAVEL_COMPENSATION;
            let jobDistance;
            if (shift.distance) {
            jobDistance = shift.distance;
          } else {
            jobDistance = shift.historyDistance ? shift.historyDistance : job.distance;
          }

          if (jobDistance) {
            let distance = jobDistance;
            travelCompensation = distance * 2 * globalTravelCompensationValue;
            if (travelCompensation > maxTravelCompensation) {
              const convertedTravelRate = formatCurrency(maxTravelCompensation);
              return convertedTravelRate;
            } else {
              travelCompensation = new Intl.NumberFormat("en-AU", {
                style: "currency",
                currency: "AUD",
              }).format(distance * 2 * globalTravelCompensationValue);
              return travelCompensation;
            }
          } else {
            const convertedTravelRate = formatCurrency(maxTravelCompensation);
            return convertedTravelRate;
          }
        } else {
          const convertedTravelRate = formatCurrency(+shift.travelCompensation);
          return convertedTravelRate;
        }
      } else {
        return "-";
      }

    };

    const onSwipeLeft = (application, index) => {
      console.log("🚀 ~ onSwipeLeft ~ job:", application);
      showActions.value[index] = true;
      // return function (direction, mouseEvent) {
      //   console.log("Swiped item ", index, ": ", job, " in direction ", direction);
      //   console.log("MouseEvent" , mouseEvent);

      // };
    };

    const onSwipeRight = (application, index) => {
      console.log("🚀 ~ onSwipeRight ~ job:", application);
      showActions.value[index] = false;
    };

    function formatDate(date) {
      return $moment(date, "YYYY-MM-DD").format("dddd, D MMMM");
    }

    const getScriptName = (scriptId) => {
      let allScript = setting.value.scripts;
      return allScript.filter((x) => x.id == scriptId)[0].name;
    };

    const getSoftwareName = (softwareId) => {
      let allScript = setting.value.software;
      return allScript.filter((x) => x.id == softwareId)[0].name;
    };

    const shouldDisplay = computed(() => {
      if (isAustralia.value && job.value?.pharmacy?.site?.id === 1) {
        return true;
      } else if (isUS.value && job.value?.pharmacy?.site?.parentId === 1) {
        return true;
      }
      return false;
    });

    (async () => {
      try {
        const settingCall = await $store.dispatch("GET_ENVIRONMENT_SETTING");
        Object.assign(setting.value, settingCall);
      } catch (error) {
        console.log(error);
      }
    })();

    const {
      checkFormValidation,
      setFormValidation,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);
    return {
      travelCompensationCount,
      showShiftInformation,
      formsData,
      checkFormValidation,
      setFormValidation,
      goToJobCalendar,
      goBack,
      goNext,
      submit,
      job,
      shifts,
      checkJobDateStart,
      routeName,
      userRole,
      featureShiftsMarkArray,
      pastShiftsMark,
      breakTimeFormat,
      userInfoModalOpen,
      userInfoModal,
      shiftEditModal,
      ApplicationsModal,
      bottomDropUp,
      bottomDropUpExist,
      actions,
      Sum,
      confirmedHours,
      Rate,
      formatHourlyRate,
      distance,
      newJobData,
      formatHourlyRatePharmacy,
      getTimeFromMinutes,
      share,
      adminChangedTravelComp,
      userData,
      handleClick,
      agencyInfoModal,
      agnecyInfoModalOpen,
      selectedApplicants,
      isSelected,
      handleCheckboxChange,
      activeCollapse,
      isValidSelect,
      isBlockShift,
      BlockApplicationsModal,
      goToJobApplicants,
      formatCurrency,
      blockPharmacy,
      moreBottomDropUp,
      SuperRate,
      totalSuperRate,
      onSwipeLeft,
      onSwipeRight,
      showActions,
      isAustralia,
      message,
      dialog,
      getCancellationReason,
      bulkShiftListToShow,
      formatDate,
      removeButtonDisabled,
      BlockShiftModal,
      calculateTravelCompensation,
      distanceInMiles,
      activeNames,
      getScriptName,
      getSoftwareName,
      shouldDisplay,
    };
  },
};
</script>
